export default "__VITE_ASSET__DLTIRqPL__"